import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luCity = {
  state: {
    luCity: [],
    selectedLuCity: {},
    selectedLuCityOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luCity(state) {
      return state.luCity
    },
    selectedLuCity(state) {
      return state.selectedLuCity
    },
    selectedLuCityOriginal(state) {
      return state.selectedLuCityOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luCity(state, payload) {
      state.luCity = payload
    },
    selectedLuCity(state, payload) {
      state.selectedLuCity = JSON.parse(JSON.stringify(payload))
    },
    selectedLuCityOriginal(state, payload) {
      state.selectedLuCityOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuCity(context, payload) {
      context.commit('selectedLuCity', payload)
    },
    loadLuCity(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuCity'
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('luCity', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    refreshSelectedLuCity(context, payload) {
      if (context.state.selectedLuCity && context.state.selectedLuCity.ID > 0) {
        context.dispatch('loadSelectedLuCity', context.state.selectedLuCity.ID)

      }
    },
    loadSelectedLuCity(context, payload) {
      if (context.state.selectedLuCity && context.state.selectedLuCity.ID != payload) {
        context.commit('selectedLuCity', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuCity/' + payload
        context.commit('increaseSearchCount')
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('selectedLuCity', res.data)
            context.commit('selectedLuCityOriginal', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    clearLookupCacheAndReloadLuCity(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadLuCity')
      }, )
    },
    createLuCity(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuCity`
        context.commit('saving', true)
        Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'city created',},{ root: true })
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuCity')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    patchLuCity(context, payload){
      return new Promise((resolve, reject) => { 
        var item = context.state.selectedLuCity
        if (payload.ID && 
        payload.ID == context.state.selectedLuCityOriginal.ID)  {
        item = payload
        }
        var patchPayload = {}
        if (!payload.patchDoc || !payload.ID) {
          let original = context.state.selectedLuCityOriginal
          let current = item
          patchPayload.ID = item.ID
          var diff = jsonpatch.compare(
                original,
                current
              )
          patchPayload.patchDoc = diff

        } else {
          patchPayload = payload
        }
        if (patchPayload.patchDoc.length > 0) {
          const url = `LuCity/${ patchPayload.ID }`
          context.commit('saving', true)
          Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          .then(
            (res) => {
              context.dispatch('messages/toastMessage',
              {color: 'success', message: 'city updated',},{ root: true })
              //if you will always need to reload the list after an update
              //you can uncomment out the following dispatch line.
              //Alternatively you can reload whatever object you need
              //when the promise resolves in the component that called it.
              //context.dispatch('loadLuCity')
              context.commit('saving', false)
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.commit('saving', false)
              context.dispatch('errors/handleError', err, { root: true })
              reject(err)
            },
          )
        } else {
          resolve('no changes')
        }
      })
    },
    updateLuCity(context, payload){
      return new Promise((resolve, reject) => { 
        const url = `LuCity/${ payload.ID }`
        context.commit('saving', true)
        Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'city updated',},{ root: true })
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuCity')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    saveLuCity(context, payload){
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuCity', payload)
          .then((res) => resolve(res), (err) => reject(err))
        } else {
          context.dispatch('createLuCity', payload)
          .then((res) => resolve(res), (err) => reject(err))
        }
      })
    },
    deleteLuCity(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuCity/${ payload.ID }`
        Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'city deleted',},{ root: true })
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuCity')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
  },
}

export default luCity